import { render, staticRenderFns } from "./CartRow.vue?vue&type=template&id=4961dc2c"
import script from "./CartRow.vue?vue&type=script&lang=js"
export * from "./CartRow.vue?vue&type=script&lang=js"
import style0 from "./CartRow.vue?vue&type=style&index=0&id=4961dc2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports